import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { ActualIconProps } from 'mobx/commonTypes';
import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import cx from 'classnames';

export default function IconDirectSpeed({
  onClick,
  isAutoscallable = true,
  sizeKey = '20x20',
  style,
}: ActualIconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconDirectSpeed', onClick ? '' : 'icon_disabled')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M2.60547 2.55156C3.63134 1.72407 4.86999 1.20302 6.1789 1.04836C7.48781 0.893705 8.81379 1.11172 10.0043 1.67733C11.1947 2.24294 12.2014 3.13316 12.9083 4.24556C13.6152 5.35796 13.9937 6.64733 14.0002 7.96533C14.0067 9.28333 13.641 10.5764 12.9452 11.6957C12.2493 12.8151 11.2516 13.7152 10.0668 14.2926C8.88193 14.87 7.55818 15.1011 6.24781 14.9594C4.93743 14.8178 3.69368 14.309 2.65966 13.4917"
        stroke="white"
      />
      <path
        d="M9.86687 8.59417L8.04869 10.4123C7.98512 10.4759 7.90413 10.5192 7.81595 10.5367C7.72778 10.5543 7.63638 10.5453 7.55332 10.5109C7.47026 10.4765 7.39927 10.4182 7.34933 10.3435C7.29938 10.2687 7.27272 10.1808 7.27272 10.0909V8.72728H0.454545C0.333992 8.72728 0.218377 8.67939 0.133133 8.59415C0.0478895 8.5089 0 8.39329 0 8.27274C0 8.15218 0.0478895 8.03657 0.133133 7.95132C0.218377 7.86608 0.333992 7.81819 0.454545 7.81819H7.27272V6.45456C7.27272 6.36466 7.29938 6.27677 7.34933 6.20202C7.39927 6.12727 7.47026 6.06901 7.55332 6.0346C7.63638 6.0002 7.72778 5.9912 7.81595 6.00873C7.90413 6.02627 7.98512 6.06956 8.04869 6.13312L9.86687 7.9513C9.95211 8.03656 10 8.15218 10 8.27274C10 8.39329 9.95211 8.50891 9.86687 8.59417Z"
        fill="white"
      />
    </svg>
  );
}
